/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    if($(this).hasClass('itg-theme-popup')){
      $(this).removeClass('hide-popup');
      $(document).find('.theme-popup-overlay').removeClass('hidden-overlay');
      $(document).find("body").attr("active-popup", 'product-model');
    }else{
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');
    }
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

document.addEventListener("click", function (event) {
  const closeSelectors = [
    ".theme-popup-overlay",
    ".theme-popup-close",
  ];

  const isCloseTrigger = closeSelectors.some(selector =>
    event.target.closest(selector)
  );

  if (isCloseTrigger) {
    const popup_overlay_close = document.querySelector('.theme-popup-overlay');
    if (popup_overlay_close) {
      popup_overlay_close.classList.add('hidden-overlay');
    }
    document.querySelectorAll(".itg-theme-popup")
      .forEach(el => el.classList.add("hide-popup"));

    if (document.body.hasAttribute("active-popup")) {
      document.body.removeAttribute("active-popup");
    }
  }
});
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (event) {
    const target = event.target.closest('[data-action="close-drawer"]');
    if (target) {
      const sidebarCart = document.querySelector("#sidebar-cart");
      if (sidebarCart) {
        sidebarCart.setAttribute("aria-hidden", "true");
      }
    }
  });
});
function renderCartDrawerSection() {
  fetch(window.location.pathname + '?section_id=cart-drawer-custom')
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.text();
    })
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const renderedContent = doc.querySelector('div[id^="sidebar-cart"]');

      const targetContainer = document.querySelector('div[id^="sidebar-cart"]');

      if (renderedContent && targetContainer) {
        targetContainer.innerHTML = renderedContent.innerHTML;
        console.log('Sidebar cart content updated successfully.');
        const closeSelectors = [
          ".theme-popup-overlay",
          ".theme-popup-close",
        ];
      
        const isCloseTrigger = closeSelectors.some(selector =>
          document.querySelector(selector)
        );
      
        if (isCloseTrigger) {
          const popup_overlay_close = document.querySelector('.theme-popup-overlay');
          if (popup_overlay_close) {
            popup_overlay_close.classList.add('hidden-overlay');
          }
          document.querySelectorAll(".itg-theme-popup").forEach(el => {
            el.classList.add("hide-popup");
          });
      
          if (document.body.hasAttribute("active-popup")) {
            document.body.removeAttribute("active-popup");
          }
        }
        targetContainer.setAttribute('aria-hidden', 'false');
      } else {
        console.warn('Sidebar cart element not found in rendered content or DOM.');
      }
    })
    .catch(error => {
      console.error('Error rendering sidebar cart section:', error);
    });
}
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.getElementById('sidebar-cart');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-popup')) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('btn--loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        // this.cart.setAttribute('aria-hidden', 'false');
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {

            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            const quickAddButton = this.querySelector('.quick-add__submit.single');
            if (quickAddButton) quickAddButton.disabled = true;
            if (!soldOutMessage) return;

            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span')?.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) {
            if (this.cart) {
              // this.cart.setAttribute('aria-hidden', 'false');
              renderCartDrawerSection();
            }
          }

          this.error = false;
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.submitButton.classList.remove('btn--loading');
          if (this.cart?.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }
          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      if (typeof errorMessage === 'object' && errorMessage['email'] === undefined) {
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      }

      if (errorMessage && typeof errorMessage === 'string') {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const galleries = document.querySelectorAll('[data-product-gallery]');

  galleries.forEach(function (gallery) {
    const images = gallery.querySelectorAll('.CustomHoverGallery__Image');

    if (images.length <= 1) return;

    let currentIndex = 0;
    let intervalId = null;

    function showImage(index) {
      images.forEach(function (img, i) {
        img.classList.toggle('is-active', i === index);
      });
    }

    gallery.addEventListener('mouseenter', function () {
      if (intervalId) return;

      intervalId = setInterval(function () {
        currentIndex = (currentIndex + 1) % images.length;
        showImage(currentIndex);
      }, 3000);
    });

    gallery.addEventListener('mouseleave', function () {
      clearInterval(intervalId);
      intervalId = null;
      currentIndex = 0;
      showImage(currentIndex);
    });
  });
});